import {Action} from '@ngrx/store';
import {FillingManagerFormExportCommand} from '../../commands/dac6-reporter.command';

export const CREATE_DAC6_REPORT = '[EntityChart] CREATE_DAC6_REPORT';
export const CREATE_DAC6_REPORT_SUCCESS = '[EntityChart] CREATE_DAC6_REPORT_SUCCESS';
export const CREATE_DAC6_REPORT_FAIL = '[EntityChart] CREATE_DAC6_REPORT_FAIL';

export const GET_BASKET = '[DAC6] GET_BASKET';
/*
export const GET_BASKET_SUCCESS = '[DAC6] GET_BASKET_SUCCESS';
export const GET_BASKET_FAIL = '[DAC6] GET_BASKET_FAIL';
export const CHANGE_BASKET = '[DAC6] CHANGE_BASKET';
*/


export const FILLING_MANAGER_FORM_EXPORT_ACTION = '[EntityChart] FILLING_MANAGER_FORM_EXPORT_ACTION';
export const FILLING_MANAGER_FORM_EXPORT_SUCCESS_ACTION = '[EntityChart] FILLING_MANAGER_FORM_EXPORT_SUCCESS_ACTION';
export const FILLING_MANAGER_FORM_EXPORT_FAILED_ACTION = '[EntityChart] FILLING_MANAGER_FORM_EXPORT_FAILED_ACTION';
export const EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_ACTION = '[EntityChart] EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_ACTION';
export const EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_FAILED_ACTION = '[EntityChart] EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_FAILED_ACTION';
export const EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_SUCCESS_ACTION = '[EntityChart] EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_SUCCESS_ACTION';
export const OTHERS_TRANSMISSION_UPDATED = '[OTHERS] TransmissionUpdated';

/*export class GetBasketAction implements Action {
  readonly type = GET_BASKET;
  constructor() {
  }
}
export class GetBasketSuccessAction implements Action {
  readonly type = GET_BASKET_SUCCESS;
  constructor(public baskets: BasketModel[]) {
  }
}
export class ChangeBasketAction implements Action {
  readonly type = CHANGE_BASKET;
  constructor(public basket: BasketModel) {
  }
}
export class GetBasketFailedAction implements Action {
  readonly type = GET_BASKET_FAIL;
  constructor(public error: any) {
  }
}*/

export class TransMissionUpdatedAction implements Action {
  readonly type = OTHERS_TRANSMISSION_UPDATED;
  constructor(public payload: any) {
  }
}
export class CreateDac6ReportAction implements Action {
  readonly type = CREATE_DAC6_REPORT;
  constructor(public command: any) {
  }
}
export class CreateDac6ReportSuccessAction implements Action {
  readonly type = CREATE_DAC6_REPORT_SUCCESS;

  constructor(public payload: any) {
  }
}
export class CreateDac6ReportFailedAction implements Action {
  readonly type = CREATE_DAC6_REPORT_FAIL;

  constructor(public error: any) {
  }
}

export class FillingManagerFormExportAction implements Action {
  readonly type = FILLING_MANAGER_FORM_EXPORT_ACTION;

  constructor(public command: FillingManagerFormExportCommand) {
  }
}
export class FillingManagerFormExportSuccessAction implements Action {
  readonly type = FILLING_MANAGER_FORM_EXPORT_SUCCESS_ACTION;

  constructor(public payload: any) {
  }
}
export class FillingManagerFormExportFailedAction implements Action {
  readonly type = FILLING_MANAGER_FORM_EXPORT_FAILED_ACTION;

  constructor(public error: any) {
  }
}

export class ExcelExportSourceFileDownloadAction implements Action {
  readonly type = EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_ACTION;

  constructor(public payload: any) {
  }
}
export class ExcelExportSourceFileDownloadSuccessAction implements Action {
  readonly type = EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_FAILED_ACTION;

  constructor(public error: any) {
  }
}
export class ExcelExportSourceFileDownloadFailedAction implements Action {
  readonly type = EXCEL_EXPORT_SOURCEFILE_DOWNLOAD_SUCCESS_ACTION;

  constructor(public payload: any) {
  }
}
export type Dac6ReporterActions =
  CreateDac6ReportAction
 | CreateDac6ReportSuccessAction
  | CreateDac6ReportFailedAction
  | FillingManagerFormExportAction
  | FillingManagerFormExportSuccessAction
  | FillingManagerFormExportFailedAction
  | ExcelExportSourceFileDownloadAction
  | ExcelExportSourceFileDownloadSuccessAction
  | ExcelExportSourceFileDownloadFailedAction
  | TransMissionUpdatedAction;



